<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <div class="dataContainer">
      <h3 class="mb-7">Sutartis</h3>

      <v-row>
        <v-col cols="12" md="6">
          <el-date-picker
            need
            :readonly="isReadonlyForm"
            :label="terminasLabel"
            :tooltip="terminasTooltip"
            v-model="formData.obj_sutartis_terminas"
            autofocus
          />
        </v-col>
        <v-col cols="12" md="6" v-if="isLizingas || isIssimoketinas">
          <el-autocomplete
            need
            :readonly="isReadonlyForm"
            :items="momentasItems"
            itemvalue="value"
            itemtext="text"
            :label="momentasLabel"
            :tooltip="momentasTooltip"
            v-model="formData.obj_sutartis_momentas_kla_id"
          />
        </v-col>
        <v-col cols="12">
          <el-textarea
            :readonly="isReadonlyForm"
            label="Kita informacija, kuri paaiškina ar patikslina sutarties duomenis"
            tooltip="Sutartis. Informacija. Kita informacija"
            :counter="2000"
            v-model="formData.obj_sutartis_kita_informacija"
          />
        </v-col>
      </v-row>
    </div>

    <hipoteka-istorija duomenys="sutarties-informacija" />

    <v-footer class="form-footer">
      <el-button primary @click.native="saveData()" :loading="loading"
        >Saugoti</el-button
      >
      <el-button @click.native="cancelData()" :loading="loading"
        >Atšaukti</el-button
      >
      <v-spacer></v-spacer>
      <el-button primary @click.native="checkErrorsClick()" :loading="loading"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import unsavedData from '../../mixins/unsavedData'
import checkErrors from '../../mixins/checkErrors'
import HipotekaIstorija from './../hipoteka/istorija/HipotekaIstorija'

export default {
  name: 'SutartisInfo',
  components: {
    HipotekaIstorija,
  },
  mixins: [unsavedData, checkErrors],
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      momentas: [],
      loading: true,
      pageloading: true,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas', 'hipotekaReadonly']),
    isReadonlyForm() {
      return this.hipotekaReadonly || this.readonlyForm
    },
    momentasItems() {
      return this.momentas.map(item => {
        return item
      })
    },
    momentasLabel() {
      return this.isLizingas
        ? 'Nuosavybės teisės perėjimo gavėjui momentas'
        : 'Nuosavybės teisės perėjimo pirkėjui momentas'
    },
    momentasTooltip() {
      return this.isLizingas
        ? 'Sutartis. Informacija. Nuosavybės teisės perėjimo momentas'
        : 'Sutartis. Informacija. Nuosavybės teisės perėjimo pirkėjui momentas'
    },
    terminasLabel() {
      if (this.isLizingas || this.isIssimoketinas) {
        return 'Galutinis atsiskaitymo terminas'
      } else if (this.isAtpirkimas) {
        return 'Atpirkimo teisės terminas'
      } else {
        return 'Terminas'
      }
    },
    terminasTooltip() {
      if (this.isLizingas || this.isIssimoketinas) {
        return 'Sutartis. Informacija. Galutinis atsiskaitymo terminas'
      } else if (this.isAtpirkimas) {
        return 'Sutartis. Informacija. Atpirkimo teisės terminas'
      } else {
        return 'Sutartis. Informacija. Terminas'
      }
    },
    isLizingas() {
      return this.hipotekaTipas.includes('lizingas')
    },
    isAtpirkimas() {
      return this.hipotekaTipas.includes('atpirkimas')
    },
    isIssimoketinas() {
      return this.hipotekaTipas.includes('issimoketinas')
    },
  },
  created() {
    this.getData()
  },

  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`objektas/${this.objektasID}/sutartisinformacija`)
        .then(res => {
          this.formData = res.data.sutartis_informacija
          this.momentas = res.data.momentas
          this.initialForm()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(toRoute, afterSave) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let data = this.formData
          data.obj_id = this.objektasID

          this.$axios
            .post(`objektas/${this.objektasID}/sutartisinformacija`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')
              if (toRoute) {
                this.goToRoute()
              } else {
                this.initialForm()
                if (afterSave === 'checkErrors') {
                  this.checkErrors()
                }
              }
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    cancelData() {
      this.getData()
    },
    checkErrorsClick() {
      this.saveData(null, 'checkErrors')
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 850px;
}
</style>
